export const FAQ = "FAQ";
export function faq(val) {
  return {
    type: FAQ,
    contentIds: val.contentIds,
    category: val.category
  };
}
